import {AfterContentChecked, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {FieldDefinition} from '@shared/models/field-definition';
import {ScenariosHandler} from '@features/scenarios-core/services/handlers/scenarios-handler.service';
import {TxpCountryCodes} from '@features/global-tax-calculator/models/txp.constants';


@Component({
    standalone: false,
    selector: 'app-gtc-hyperlink-cell-viewer',
  templateUrl: './gtc-hyperlink-cell-viewer.component.html',
  styleUrl: './gtc-hyperlink-cell-viewer.component.scss'
})
export class GtcHyperlinkCellViewerComponent implements OnInit, AfterContentChecked, CellComponent {
  item: any;
  sourceType?: string;
  fieldDefinition: FieldDefinition;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  validationChange?: EventEmitter<boolean>;
  invalidateSubject?: InvalidateSubject;
  disabled?: boolean;
  extras?: any;
  isLegacyTemplate = false;

  private isTemplateUpdateAvailable = {};
  private isCountryTrackerUpdateAvailable = {};
  tags: string[];
  currentScenarioType: string;
  versionTooltips: {
    [key: string]: string;
  };
  templateUpdateChoices: any;
  tagClassMap = {
    ScheduleUpdates: 'scheduled'
  };
  isLocked: boolean;
  lockedScenarioMessage = `<div class="lock-tooltip-container"><h2>Locked Scenario</h2>
  <p style="color:#B7BFCC">This scenario has been locked, which prevents further edits and data inputs. Open this scenario to view the contents and to generate additional reports.</p></div>`;
  constructor(private handler: ScenariosHandler) { }

  ngOnInit(): void {
    this.currentScenarioType = this.item.cells['CurrentScenarioType']?.value;
    this.tags = this.item.cells['ScenarioType']?.value;
    this.versionTooltips = this.item.cells['VersionTooltips']?.value;
    this.templateUpdateChoices = {
      'GMT': this.item.cells[`UpdateChoice-GMT`]?.value,
      'ITC': this.item.cells[`UpdateChoice-ITC`]?.value,
      'CbC': this.item.cells[`UpdateChoice-CbC`]?.value
    };

    this.SetTemplateUpdateInfo();
    this.SetCountryTrackerUpdateInfo();
  }
  ngAfterContentChecked(): void {
    this.isLocked = this.item.cells['IsLocked']?.value;
  }

  private SetCountryTrackerUpdateInfo() {
    if (this.item.cells[`${this.currentScenarioType}-UpdatedCountryTrackerVersion`] && this.item.cells[`${this.currentScenarioType}-CurrentCountryTrackerVersion`]) {
      this.isCountryTrackerUpdateAvailable[this.currentScenarioType] = this.item.cells[`${this.currentScenarioType}-UpdatedCountryTrackerVersion`].value !== this.item.cells[`${this.currentScenarioType}-CurrentCountryTrackerVersion`].value;
    }
  }
  private SetTemplateUpdateInfo() {
    if (this.item.cells[`${this.currentScenarioType}-UpdatedVersion`] && this.item.cells[`${this.currentScenarioType}-CurrentVersion`]) {
      let isLegacyTemplate = this.item.cells[`Is${this.currentScenarioType}LegacyTemplate`]
      if (isLegacyTemplate.value) {
        this.isLegacyTemplate = true;
        this.isTemplateUpdateAvailable[this.currentScenarioType] = false
      } else {
        this.isTemplateUpdateAvailable[this.currentScenarioType] = this.item.cells[`${this.currentScenarioType}-UpdatedVersion`].value !== this.item.cells[`${this.currentScenarioType}-CurrentVersion`].value;
      }
    }
    TxpCountryCodes.forEach(subType => {
      const updatedKey = `${this.currentScenarioType}-${subType}-UpdatedVersion`;
      const currentKey = `${this.currentScenarioType}-${subType}-CurrentVersion`;
      if (this.item.cells[updatedKey] && this.item.cells[currentKey]) {
        const hasUpdate = this.item.cells[updatedKey].value !== this.item.cells[currentKey].value;
        this.isTemplateUpdateAvailable[`${this.currentScenarioType}-${subType}`] = hasUpdate;
        if (hasUpdate) {
          this.isTemplateUpdateAvailable[this.currentScenarioType] = true;
        }
      }
    });
  }
  onClick($event: MouseEvent) {
    if ((this.item && !this.item.isReadOnly)) {
      this.valueChanged.emit({
        item: this.item,
        fieldDefinition: this.fieldDefinition,
      });
    }
  }

  GetScenarioTypeFromTag(tag: string) {
    switch (tag) {
      case 'CBC':
        return 'CbC';
      default:
        return tag;
    }
  }

  onTagClick($event: any, tag: string) {
    $event.stopPropagation();
    const command = this.handler?.magicLinkModel.additionalCommands['ScenarioName'];
    if (command) {
      command.fieldValues['ScenarioId'] = this.item.id;
      command.fieldValues['ScenarioType'] = this.GetScenarioTypeFromTag(tag);
      this.handler.executeCommand(command);
    }
  }




}
